import { IonChip } from '@ionic/react'
import { useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { driverModel } from '~/entities/Driver'
import { STATUS_VARIANT } from '~/shared/config/constants'
import { DriverStatusEnum } from '~/shared/config/enums'

export function DriverStatus() {
  const status = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getStatus(),
  )
  const statusComment = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getStatusComment(),
  )

  const variant = useMemo(() => {
    switch (status) {
      case DriverStatusEnum.APPROVED:
      case DriverStatusEnum.FIRED:
        return 'green'
      case DriverStatusEnum.REJECTED:
        return 'red'
      default:
        return 'yellow'
    }
  }, [status])

  const customVariant = useMemo(() => {
    if (variant === 'green') return STATUS_VARIANT['green']
    if (variant === 'red') return STATUS_VARIANT['red']
    if (variant === 'yellow') return STATUS_VARIANT['yellow']
  }, [variant])

  const style = useMemo(() => {
    if (!customVariant) return
    return {
      '--background': customVariant.backgroundColor,
      '--color': customVariant.color,
      ...(customVariant?.border ? { border: customVariant?.border } : {}),
    }
  }, [customVariant])

  if (!statusComment) return null

  return (
    <IonChip style={{ ...style, margin: 0, borderRadius: '8px' }}>
      {statusComment || status}
    </IonChip>
  )
}
